import { Dispatch, useCallback } from "react";

import { PhoneNumber } from "../../../../Models/PhoneNumber";
import { useGem } from "../../../../Utils/UseGem";

const useUpsertPhoneNumbers = () => {
  const { res, loading, setReq } = useGem<PhoneNumber, PhoneNumber>();
  const setRequest: Dispatch<PhoneNumber> = useCallback(
    phoneNumber =>
      setReq({
        method: phoneNumber?.id ? "put" : "post",
        url: `Legacy/V0/PhoneNumbers${phoneNumber?.id ? `/${phoneNumber.id}` : ""}`,
        payload: phoneNumber
      }),
    []
  );
  return { res: res?.payload, loading, setRequest };
};

export default useUpsertPhoneNumbers;
